import type { CanvasElementType } from "../types";

/** Defaults required for a newly added builder element to save as valid data. */
export function applyCanvasBuilderElementDefaults(
  type: CanvasElementType,
  defaultProps: Record<string, unknown> = {},
): Record<string, unknown> {
  if (type === "text") {
    return { textVariant: "text", ...defaultProps };
  }

  return { ...defaultProps };
}
